import React from "react"
import { DotProps } from "react-multi-carousel"
import clsx from "clsx"

export const SliderDot: React.FC<DotProps> = ({ active, onClick }) => {
  return (
    <button
      className={clsx(
        "sm:h-3.5 sm:w-3.5 sm:mx-[5px] rounded-full h-2 w-2 mx-[2.5px]",
        active ? "bg-green" : "bg-grey-ec"
      )}
      onClick={(e) => {
        if (onClick) {
          onClick()
        }
        e.preventDefault()
      }}
    />
  )
}
